"use client"

import { useId, useState } from "react"
import { EyeIcon, EyeOffIcon, LockIcon } from "lucide-react"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export default function PasswordField({ id, name, value, onChange, ...props }) {
   const [isVisible, setIsVisible] = useState(false)

   const toggleVisibility = () => setIsVisible((prevState) => !prevState)

   return (
      <div className="*:not-first:mt-2">
         {/* <Label htmlFor={id}>Show/hide password input</Label> */}
         <div className="relative">
            <Input
               id={id}
               name={name}
               className="peer ps-9"
               placeholder="Password"
               value={value}
               onChange={onChange}
               type={isVisible ? "text" : "password"} {...props} />
            <div
               className="text-muted-foreground/80 pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 peer-disabled:opacity-50">
               <LockIcon size={16} aria-hidden="true" />
            </div>
            <button
               className="text-muted-foreground/80 hover:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 absolute inset-y-0 end-0 flex h-full w-9 items-center justify-center rounded-e-md transition-[color,box-shadow] outline-none focus:z-10 focus-visible:ring-[3px] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
               type="button"
               onClick={toggleVisibility}
               aria-label={isVisible ? "Hide password" : "Show password"}
               aria-pressed={isVisible}
               aria-controls="password">
               {isVisible ? (
                  <EyeOffIcon size={16} aria-hidden="true" />
               ) : (
                  <EyeIcon size={16} aria-hidden="true" />
               )}
            </button>
         </div>
      </div>
   );
}
